import React, { useEffect, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { Form, Schema } from 'rsuite'
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons'
import { useNavigate } from 'react-router-dom';
import Information from '../../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/PeInformation';
import applicationService from '../../../../../../services/Public/Application/PE/peApplication.service';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import Issues from '../../../../../Shared/Card/Issues';
import DocumentUpload from '../../../../../Shared/Upload/DocumentUpload';

function QuizzesPage() {
    const appId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const [hasFiles, setHasFiles] = useState(false);
    const routes = useSelector(x => x.currentRoutes);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const appType = appTypeId == 3 ? "By Comity" : appTypeId == 4 ? "By Exam" : "";
    const sectionId = 6;
    useEffect(() => {
        applicationService.peGetSection(appId, sectionId).then((response) => {
            setSectionData(response.data)
            setHasLoaded(true);
        })
    }, [])

    const push = useNavigate();

    const handleSubmit = (val, event) => {
        if (hasFiles) {
            nextSectionNavigation()
        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <b>Professional Engineer Application {appType}</b>
                <h4 className="mb-3">Quizzes</h4>
                <Information content={GetAppInformationContent("quiz")} />
                <br />
                {hasLoaded ?
                    <Form onSubmit={handleSubmit} fluid> {/*This is to make sure validation is triggered and form does nothing else*/}
                        <Card>
                            <Card.Header>
                                <h6>Document Uploads</h6>
                            </Card.Header>
                            <Card.Body>
                                <DocumentUpload
                                    isUserEditable={sectionData.isUserEditable}
                                    credentialTypeId={6}
                                    sectionId={sectionId}
                                    appTypeId={appTypeId}
                                    //refreshData={ }
                                    parentId={sectionData.id}
                                    parentTypeId={1}
                                    setHasFiles={setHasFiles}
                                />
                                {!hasFiles && <div className="text-danger">Please select at least 1 file.</div>}
                            </Card.Body>
                        </Card>
                        <br />
                        <Issues isUserEditable={true} type={1} sectionId={sectionData.id} />
                        <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/individual/peApp/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    )
}
export default QuizzesPage;